import { render, staticRenderFns } from "./refreshApiToken.vue?vue&type=template&id=5185fc5a&scoped=true&"
import script from "./refreshApiToken.vue?vue&type=script&lang=js&"
export * from "./refreshApiToken.vue?vue&type=script&lang=js&"
import style0 from "./refreshApiToken.vue?vue&type=style&index=0&id=5185fc5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185fc5a",
  null
  
)

export default component.exports